export default {
	// Config
	apiKey: "AIzaSyDFuQDYzghp3Qewtndg_Is0YpxFGnk5Jq8",
  authDomain: "stealthyair-mytrace.firebaseapp.com",
  projectId: "stealthyair-mytrace",
  storageBucket: "stealthyair-mytrace.firebasestorage.app",
  messagingSenderId: "446757167893",
  appId: "1:446757167893:web:bab9317c5690c8abfb7f1c"
};
